// extracted by mini-css-extract-plugin
export default {"logo":"PageLogo_logo__j-W0Y","absolute":"PageLogo_absolute__cTCZ8","fixed":"PageLogo_fixed__ReTCy"};